import { Box, Button, CircularProgress, Grid, IconButton, Typography } from '@mui/material'
import SimpleModal from 'src/Component/SimpleModal'
import InputField from 'src/Component/InputField'
import { Controller } from 'react-hook-form'
import FileInput from 'src/Component/FileInput'
import editIconRedBg from 'src/assets/icons/editIconRedBg.png'
import SimpleDropdown from 'src/Component/SimpleDropdown'
import { timeOptions, trainingLevelOptions } from 'src/utils/constants'
import useEditAITrainer from './useEditAITrainer'

type EditAITrainerModalProps = {
  id: number
  open: boolean
  onClose: () => void
  successCallback: () => void
  onDeleteClick: (id: number) => void
}
const EditAITrainerModal = ({
  id,
  open,
  onClose,
  successCallback,
  onDeleteClick,
}: EditAITrainerModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingEditAITrainer,
    videoUrl,
    showUploadImage,
    handleShowUploadImage,
  } = useEditAITrainer({
    successCallback,
    id,
  })


  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            {showUploadImage || !videoUrl ? (
              <FileInput
                type='video'
                title='You can click me to upload files!'
                discription='Support for video file formats (.mp4, .wav, .mkv)'
                name='fileuplaod'
                value={file}
                onChange={handleFileChange}
                showPreview
              />
            ) : (
              <Box textAlign='center' position='relative' minHeight='50px'>
                <video
                  src={videoUrl}
                  style={{
                    height: '250px',
                    width: 'auto',
                    objectFit: 'cover',
                  }}
                  controls
                />
                <Box
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                >
                  {' '}
                  <IconButton onClick={handleShowUploadImage}>
                    <img src={editIconRedBg} />
                  </IconButton>
                </Box>
              </Box>
            )}
            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter Branch Gym name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.name.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='equipmentNeeded'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Equipment Needed'
                        placeholder='Enter Equipment Needed'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.equipmentNeeded}
                        required
                      />
                      {!!errors.equipmentNeeded && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.equipmentNeeded.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='time'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        name={field.name}
                        value={field.value}
                        label={'Time'}
                        options={timeOptions}
                        onChange={field.onChange}
                        // error={!!errors.time}
                        placeholder='Select Time'
                        required
                      />

                      {!!errors.time && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.time.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='trainingLevel'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        name={field.name}
                        value={field.value}
                        label={'Training Level'}
                        options={trainingLevelOptions}
                        onChange={field.onChange}
                        // error={!!errors.trainingLevel}
                        placeholder='Training Level'
                        required
                      />
                      {!!errors.trainingLevel && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.trainingLevel.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='instruction'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        multiline
                        rows={4}
                        label='Instruction'
                        placeholder='Enter the Instruction'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.instruction}
                        required
                      />
                      {!!errors.instruction && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.instruction.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant='contained'
              color='secondary'
              type='submit'
              disabled={isLoadingEditAITrainer}
            >
              {isLoadingEditAITrainer ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
            <Button
              onClick={() => onDeleteClick(id)}
              sx={{ marginLeft: '20px' }}
              variant='contained'
              color='primary'
              type='button'
            >
              DELETE
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default EditAITrainerModal
